// extracted by mini-css-extract-plugin
export default {"root":"DrillxInput_root__ItImz","input":"DrillxInput_input__cOmYQ","focused":"DrillxInput_focused__fhdES"};